export async function timeout(timestamp: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(() => resolve(), timestamp);
  });
}
